const path = require('path');
const fs = require('fs');

module.exports = {
    devServer: {
        port:8088,
        proxy: {
            '/': {
                target: 'http://localhost:15383',
                bypass: (req, res, proxyOptions) => {
                    // Serve basic.css, home.css, and extra.css from local project
                    const cssMap = {
                        '/dist/pbcss/basic.css': 'public/pbcss/basic.css',
                        '/css/themes/cs/home.css': 'public/pbcss/home.css',
                        '/css/extra.css': 'public/pbcss/css/extra.css',
                        '/bll/shopx.js': 'public/bll/shopx.js',
                        '/bll/shoppingCartX.js': 'public/bll/shoppingCartX.js',
                        '/aitl/init.js': 'public/aitl/init.js',
                        '/aitl/overlay.css': 'public/aitl/overlay.css'
                    };
                    
                    if (cssMap[req.url]) {
                        const localPath = path.join(__dirname, cssMap[req.url]);
                        if (fs.existsSync(localPath)) {
                            res.setHeader('Content-Type', 'text/css');
                            res.end(fs.readFileSync(localPath));
                            return false; // prevent proxying
                        }
                    }
                }
            }
        }
    },
    filenameHashing: false,
    chainWebpack: config => {
        config.externals({
            'jquery': 'jQuery',
            'jdr': 'jdr',
            'aitl': 'aitl',
            'apiClientRef': 'apiClient',
            'uiClientRef': 'uiClient',
            'intLangRef':'intLang'
        })
    },
    runtimeCompiler: true,
    //outputDir: '../../NetcoreApi/wwwroot/dist',//process.env.outputDir,
    publicPath: "./",
    pages: {
        macbackend: {
            entry: 'src/dashboard.js',
            template: 'public/templ.dashboard.mac.html',
            filename: 'dashboard-mac.html',
            //filename: 'index.html',
        },
        macfrontend: {
            entry: 'src/main.js',
            template: 'public/templ.shop.mac.html',
            //filename: 'shop-mac.html',
            filename: 'index.html',
        },
        shop: {
            entry: 'src/main.js',
            template: 'public/templ.shop.html',
            filename: 'shop.html',
        },
        dashboard: {
            entry: 'src/dashboard.js',
            template: 'public/templ.dashboard.html',
            filename:'dashboard.html'
        },
        editpost: {
            entry: 'src/post.js',
            template: 'public/empty.html',
            filename: 'post.html'
        },
        unitTest: {
            entry: 'src/unitTest.js',
            template: 'public/templ.unitTest.html',
            filename: 'unitTest.html'
        }
    }
}